/**
 * @file Album Selection Button.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AlbumSelectionsIcon from '../icons/AlbumSelectionsIcon';
import Button from '../global/Button';
import Badge from '../global/Badge';

const propTypes = {
  identity: PropTypes.shape({
    selectedAlbums: PropTypes.array,
  }).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

const AlbumSelectionButton = ({ identity, onClick, className }) => {
  const selectedAlbums = identity?.selectedAlbums?.length ?? 0;
  const classes = classNames({
    'album-selection-button': true,
    [className]: !!className,
  });

  return (
    <Button
      btnStyle="reset"
      className={classes}
      disabled={selectedAlbums === 0}
      onClick={onClick}
    >
      <Badge badgeStyle="yellow" round className="d-flex align-items-center">
        <AlbumSelectionsIcon
          color="#000"
          width="16px"
          height="16px"
          className="mr-1"
        />
        <span className="text-extra-bold">{selectedAlbums}</span>
      </Badge>
    </Button>
  );
};

AlbumSelectionButton.propTypes = propTypes;

export default AlbumSelectionButton;
